import React from "react";
import { style } from "./Cards.css";
import { Box, Card, CardContent, Typography } from "@mui/material";
import Bulb from "../Image/bulbIcon.png";
import ValuePropositionsIcon from "../Image/valueIcon.png";
import CapabilitiesIcon from "../Image/capabilitiesIcon.png";

const Examples = [
  "How can AI help my company?",
  "What kind of accelerators does Konverge have?",
  "What services does Konverge provide?",
];

const Capabilities = ["Data Science", "Data Products", "Data Engineering"];

const ValuePropositions = ["For Startups", "For SMBs", "For Enterprises"];

const ValuePropositionsQuestions = [
  "Why Konverge.AI for Startups?",
  "Why Konverge.AI for SMB's?",
  "Why Konverge.AI for Enterprises?",
];

const CapabilitiesQuestions = [
  "What data science and engineering services does konverge provide?",
  "What data products engineering services does konverge provide?",
  "What cloud data engineering services does konverge provide?",
];

const Cards = ({ setExampleQuestions }) => {
  const examplesHandler = (e) => {
    setExampleQuestions(e.target.textContent);
  };

  const valuePropositionHandler = (e) => {
    if (e.target.textContent === ValuePropositions[0]) {
      setExampleQuestions(ValuePropositionsQuestions[0]);
    } else if (e.target.textContent === ValuePropositions[1]) {
      setExampleQuestions(ValuePropositionsQuestions[1]);
    } else {
      setExampleQuestions(ValuePropositionsQuestions[2]);
    }
  };

  const capabilitiesHandler = (e) => {
    if (e.target.textContent === Capabilities[0]) {
      setExampleQuestions(CapabilitiesQuestions[0]);
    } else if (e.target.textContent === Capabilities[1]) {
      setExampleQuestions(CapabilitiesQuestions[1]);
    } else {
      setExampleQuestions(CapabilitiesQuestions[2]);
    }
  };

  return (
    <Box sx={style.cardBox}>
      <Box sx={style.cardChildBox}>
        <Box sx={style.heightCard}>
          <Box sx={style.iconTextBox}>
            <Box component="img" src={Bulb} sx={style.bulbIcon} />
            <Typography sx={style.examplesText}>Examples</Typography>
          </Box>
          {Examples.map((list, index) => {
            return (
              <div key={index} onClick={examplesHandler} sx={style.cardsBtn}>
                <Card sx={style.cards}>
                  <CardContent sx={style.cardsContentFirstColumn}>
                    {list}
                  </CardContent>
                </Card>
              </div>
            );
          })}
        </Box>
        <Box>
          <Box sx={style.iconTextBox}>
            <Box
              component="img"
              src={ValuePropositionsIcon}
              sx={style.bulbIcon}
            />
            <Typography sx={style.examplesText}>Value Propositions</Typography>
          </Box>
          {ValuePropositions.map((list, index) => {
            return (
              <div
                key={index}
                onClick={valuePropositionHandler}
                sx={style.cardsBtn}
              >
                <Card sx={style.cards}>
                  <CardContent sx={style.cardsContent}>
                    {list}
                  </CardContent>
                </Card>
              </div>
            );
          })}
        </Box>
        <Box>
          <Box sx={style.iconTextBox}>
            <Box component="img" src={CapabilitiesIcon} sx={style.bulbIcon} />
            <Typography sx={style.examplesText}>Capabilities</Typography>
          </Box>
          {Capabilities.map((list, index) => {
            return (
              <div
                key={index}
                onClick={capabilitiesHandler}
                sx={style.cardsBtn}
              >
                <Card sx={style.cards}>
                  <CardContent sx={style.cardsContent}>
                    {list}
                  </CardContent>
                </Card>
              </div>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default Cards;
